<template>
  <div class="box">
	  <ComNar title="星巴克在线代点餐"></ComNar>
	  <div class="inner-box">
		<ComShopLocation></ComShopLocation>
		<div class="goods-detail-div">
		  <PayGoods></PayGoods>
      <UserAmount></UserAmount>
		  <PayCoupon></PayCoupon>
		  <Phone @success="canPay"></Phone>
		</div>
  
		<PayMoney @openPayType="canPay()" ref="payMoneyRef"></PayMoney>
		<van-action-sheet
		  v-model="showPayType"
		  :round="false"
		  :closeable="false"
		  :overlay="htmlShowPayType"
		>
		  <PayType
			orderId=""
			:code="code"
			ref="payTypeRef"
			v-show="htmlShowPayType"
			@errorPay="doError"
			@success="doSuccess"
		  ></PayType>
		</van-action-sheet>
		<div class="emtry-div"></div>
	  </div>
    <!-- <van-overlay z-index="100" :show="showPaiedLoading" @click="showPaiedLoading=false">
	</van-overlay> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import ComShopLocation from "../components/goods/ComShopLocation.vue";
import PayGoods from "../components/pay/PayGoods.vue";
import PayCoupon from "../components/pay/PayCoupon.vue";
import Phone from "../components/pay/Phone.vue";
import PayMoney from "../components/pay/PayMoney.vue";
import UserAmount from "../components/pay/UserAmount.vue";
import PayType from "../components/pay/PayType.vue";
import ComNar from "@/components/searchShop/ComNar.vue";
import { ActionSheet, Notify,Overlay,Loading } from "vant";
export default {
  name: "pay",
  computed: mapGetters(["sUserInfo", "sOrderCode", "orderPrice"]),
  components: {
    [ComShopLocation.name]: ComShopLocation,
    [PayGoods.name]: PayGoods,
    [PayCoupon.name]: PayCoupon,
    [Phone.name]: Phone,
    [PayMoney.name]: PayMoney,
    [PayType.name]: PayType,
    [UserAmount.name]: UserAmount,
    [ActionSheet.name]: ActionSheet,
    [Notify.name]: Notify,
	[Loading.name]:Loading,
	[Overlay.name]:Overlay,
    [ComNar.name]: ComNar,
  },
  data() {
    return {
      showPayType: false,
      code: "",
      htmlShowPayType: true,
	//   showPaiedLoading:false,// 支付后等待结果
    };
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations(["setOrderCode", "clearCouponId"]),
    init() {
      this.clearCouponId();
      // let browserFlag = this.isWechat();
      // if (browserFlag == 0) {
      // 	let code = this.$getUrlParam("code")
      // 	if (!code && !this.sOrderCode) {
      // 		this.getCode()
      // 	} else {
      // 		if(code){
      // 			// this.setOrderCode(code)
      // 			// let uri =  window.location.href
      // 			this.setOrderCode(code)
      // 			this.code = code;
      // 			// uri = uri.split("?")[0]+'#/pay'
      // 			// window.location.replace(uri)
      // 		}else{
      // 			this.code = this.sOrderCode
      // 			this.setOrderCode('')
      // 		}
      // 	}
      // }
    },
    doSuccess(orderId) {
      // if (this.orderId) {
      // 	this.setOrderId(this.orderId);
      // 	this.$router.push({
      // 		name: 'orderDetail',
      // 		params: {
      // 			orderId: this.orderId
      // 		}
      // 	})
      // }
      if (orderId) {
        this.$router.push({
          name: "orderDetail",
          params: {
            orderId: orderId
          },
        });
      }
      // this.$router.replace({
      // 	name: 'historyOrder'
      // })
      // this.$emit('loadCode')
    },
    doError(bool) {
      // 组件支付失败后的事件，
      // this.showPayType = bool
    },
    canPay() {
      if (this.sUserInfo.mobile) {
        if (this.orderPrice == 0) {
          this.htmlShowPayType = false;
        } else {
          this.htmlShowPayType = true;
        }
        this.showPayType = true;
        // return;
        this.$nextTick(() => {
          if (this.orderPrice == 0) {
            this.$refs.payTypeRef.payType = "2";
            this.$refs.payTypeRef.createOrder();
          } else {
            this.$refs.payTypeRef.payType = "0";
          }
          // this.$refs.payTypeRef.payType = "0";
        });
      } else {
        //滚动条
        setTimeout(() => {
          this.scrollToBottom();
        }, 40);
        Notify({ type: "danger", message: "请绑定手机" });
      }
    },
    getCode() {
      let payBack = window.location.href;
      let appId = "wx3de49bcab72a4020"
      // 测试环境
      // let appId = "wxeade3e34841010b2";
      let codeUri =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        appId +
        "&redirect_uri=" +
        encodeURIComponent(payBack) +
        "&response_type=code&scope=snsapi_base#wechat_redirect";
      window.location.href = codeUri;
    },
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return 0;
      } else {
        return 1;
      }
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href.split("#")[0];
      let search = url.split("?")[1];
      if (search) {
        var r = search.substr(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else {
        return null;
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        let container = this.$el.querySelector(".inner-box");
        container.scrollTop = container.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
.box,
.inner-box {
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: auto;
  background-color: #f5f5f5;
}

.goods-detail-div {
  padding: 10px;
}
.emtry-div {
  width: 100%;
  height: 80px;
}
</style>
